<template>
  <v-list-item v-if="visible" :to="route">
    <v-list-item-action>
      <v-icon light v-text="icon" class="fa-fw"></v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title v-text="title"></v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    title: String,
    icon: String,
    route: Object,
    visible: { type: Boolean, default: true }
  }
}
</script>

<style scoped lang="scss">
.v-list {
  .v-list-item {
    .v-list-item__action {
      min-width: unset;
      margin-right: 16px;
    }

    .v-list-item__title {
      font-size: 16px;
    }
  }
}

.v-list-item--active {
  background-color: var(--v-grey-lighten3);

  .v-list-item__action {
    color: var(--v-grey-darken3);
  }

  .v-list-item__content {
    font-weight: bolder;
    color: var(--v-grey-darken4);
  }
}
</style>
